import { cn } from "@/lib/utils";
import { ChatInput } from "./chat/ChatInput";
import { ActionButtons } from "./chat/ActionButtons";
import { AIProgressBar } from "../AIProgressBar";

interface ChatInputSectionProps {
  userInput: string;
  onChange: (value: string) => void;
  onSend: () => void;
  isLoading?: boolean;
  isAnalyzing?: boolean;
  isGenerating?: boolean;
  onFileUpload: () => void;
  onCreateDocument: () => void;
  onCreateCase: () => void;
  onLawSearch: () => void;
  messagesExist: boolean;
  progress?: number;
  canGenerateDocument: boolean;
}

export function ChatInputSection({
  userInput,
  onChange,
  onSend,
  isLoading,
  isAnalyzing,
  isGenerating,
  onFileUpload,
  onCreateDocument,
  onCreateCase,
  onLawSearch,
  messagesExist,
  progress,
  canGenerateDocument
}: ChatInputSectionProps) {
  return (
    <div className="space-y-4 px-[2.5%] md:px-4 py-2 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <ChatInput
        value={userInput}
        onChange={onChange}
        onSend={onSend}
        onFileUpload={onFileUpload}
        isLoading={isLoading}
      />

      <AIProgressBar 
        progress={progress || 0} 
        isAnalyzing={isAnalyzing} 
      />

      {messagesExist && (
        <ActionButtons
          onCreateDocument={onCreateDocument}
          onCreateCase={onCreateCase}
          onLawSearch={onLawSearch}
          isGenerating={isGenerating || false}
          canShowActions={canGenerateDocument}
          className="mb-2"
        />
      )}
    </div>
  );
}